import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import easing from 'ui/styles/easing'
import { media } from 'styled-bootstrap-grid'

const pulse = keyframes`
  0%, 35% {
    transform: translateY(0);
  }

  12% {
    transform: translateY(50%);
  }
`

const Wrapper = styled.div`
  position: absolute;
  left: 50px;
  bottom: 50px;
  z-index: 1;
  animation: ${pulse} 5s infinite ${easing.easeOutQuart};

  ${media.xs`
    left: 15px;
    bottom: 85px;
  `}
`

export default class Arrow extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43"
          height="42"
        >
          <path
            fill="#FFF"
            stroke="#FFF"
            d="M18.85 1.2v31.11L4.57 18.03 1 21.6 21.4 42l20.4-20.4-3.57-3.57-14.28 14.28V1.2z"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Hero/Arrow.js